import { render, staticRenderFns } from "./UserSelectionComponent.vue?vue&type=template&id=2fff374a"
import script from "./UserSelectionComponent.vue?vue&type=script&lang=js"
export * from "./UserSelectionComponent.vue?vue&type=script&lang=js"
import style0 from "./UserSelectionComponent.vue?vue&type=style&index=0&id=2fff374a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.32_css-loader@6.11.0_webpack@5.106.2__lodash@4_9acdcff83b5891d2d7c120609da332e7/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports